
import { searchByPropertyValue } from "@/api/map";
import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { getPropertiesToSearchBy } from "@/api/nomenclatures";

@Component({
  components: {
  },
  computed: {
    ...mapGetters(["tag_refs"]),
  },
})
export default class SearchByProperty extends Vue {
  public dataContainer: object[];
  public selectedData: object;
  public loading: boolean;
  public panel: number[];
  public innerPanel: number[];
  public searchProperties: any[];
  public termData: { field: string | null; term: string | null };

  @Watch("$store.getters.token")
  onBearerTokenPresent() {
    this.loadPropertiesToSearchBy();
  }

  constructor() {
    super();
    this.dataContainer = [];
    this.selectedData = {};
    this.loading = false;
    this.panel = [];
    this.innerPanel = [];
    this.searchProperties = [];
    this.termData = {
      field: null,
      term: null,
    };
  }
  onItemClick(item, source, layer) {
    this.selectedData = {
      item,
      source,
      layer,
    };
    this.$store.dispatch("map/changeSearchFeature", this.selectedData);
  }

  loadPropertiesToSearchBy() {
    getPropertiesToSearchBy().then((res) => {
      this.searchProperties = res.data as any;
    });
  }

  onSearch() {
    if (this.termData.term) {
      this.loading = true;
      searchByPropertyValue(this.termData)
        .then((result) => {
          this.dataContainer = [...result.data];
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
